import { RegionInputConfig } from "@smithy/config-resolver";
import { LoginDataStorageKey } from "app-constants";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { Logins } from "@aws-sdk/credential-provider-cognito-identity";
import type { AwsCredentialIdentityProvider } from "@aws-sdk/types";

import configureAws from "aws-configurator";
import { ReplaySubject } from "rxjs/internal/ReplaySubject";
const config = configureAws();

export interface AwsClientConfig extends RegionInputConfig {
  credentials: AwsCredentialIdentityProvider;
}

export function clearLoginData() {
  localStorage.removeItem(LoginDataStorageKey);
  awsClientConfigSubject.next(null);
}

export const awsClientConfigSubject = new ReplaySubject<AwsClientConfig | null>();

export function setLoginData(logins: Logins) {
  localStorage.setItem(LoginDataStorageKey, JSON.stringify(logins));
  awsClientConfigSubject.next(getAwsServiceClientConfig(logins));
}

export function getLoginData(): Logins | undefined {
  if (!import.meta.env.SSR) {
    const loginDataStr = localStorage.getItem(LoginDataStorageKey);
    const loginData = !!loginDataStr ? JSON.parse(loginDataStr) : undefined;
    return loginData;
  } else {
    return undefined;
  }
}

export function getAwsServiceClientConfig(loginData?: Logins): AwsClientConfig {
  return {
    region: config.aws_cognito_region,
    credentials: fromCognitoIdentityPool({
      clientConfig: { region: config.aws_cognito_region }, // Configure the underlying CognitoIdentityClient.
      identityPoolId: config.aws_cognito_identity_pool_id,
      logins: loginData ?? getLoginData()
    })
  }
}
